'use strict';

import $ from 'jquery';
const prepareCheckDropdown = () => {
  const projectId = $('meta[name=project-id]').attr('content');
  if (projectId) {
    $(`.projects-dropdown input[name="projects[]"][value="${projectId}"]`)
      .prop('checked', true)
      .trigger('change');
  } else {
    $('.projects-dropdown input[name="item[in_library]"]').trigger('change');
  }

  // if there is no project, in_library checkbox should alwasy be selected
  if (!$('.projects-dropdown input[name="projects[]"]').length) {
    $('.projects-dropdown input[name="in_library"]').prop('disabled', true);
  }
};
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  const config = {
    maxAdditionalImages: 8,
  };

  // Variables for analytics
  let autoPopulatedProperties = {};
  let updatePropertiesCount = 0;
  let elapsedTime = null;

  function resetAnalytics() {
    autoPopulatedProperties = {};
    updatePropertiesCount = 0;
    elapsedTime = null;
  }

  function calculateAnalytics(formValues) {
    const analytics = {
      fields_auto_count: 0,
      fields_corrected_count: 0,
      fields_manual_count: 0,
      time_to_finalize: null,
    };

    if (elapsedTime) {
      analytics.time_to_finalize = Math.round((Date.now() - elapsedTime) / 1000);
    }

    Object.keys(formValues).forEach((field) => {
      const currentValue = formValues[field];
      const autoValue = autoPopulatedProperties[field];
      const hasCurrentValue =
        currentValue !== '' &&
        currentValue !== null &&
        currentValue !== undefined &&
        currentValue !== 0 &&
        currentValue !== '0';

      if (!hasCurrentValue) {
        return;
      }

      const wasAutoPopulated = field in autoPopulatedProperties;
      const hasAutoValue =
        autoValue !== '' &&
        autoValue !== null &&
        autoValue !== undefined &&
        autoValue !== 0 &&
        autoValue !== '0';

      if (wasAutoPopulated && hasAutoValue) {
        analytics.fields_auto_count++;

        const autoValueStr = String(autoValue);
        const currentValueStr = String(currentValue);

        if (autoValueStr !== currentValueStr) {
          analytics.fields_corrected_count++;
        }
      } else {
        analytics.fields_manual_count++;
      }
    });

    return analytics;
  }

  function setElapsedTimeToNow() {
    elapsedTime = Date.now();
  }

  $(function () {
    if ($('body').is('#bookmarklet')) {
      // overwrite default click event on draggable button, so it doesn't open the clipper panel
      $(document).on('click', '.bookmarklet-page__callout-button', (e) => {
        e.preventDefault();
      });
      $(document).on('mouseenter', '.bookmarklet-page__example', () => {
        $('.bookmarklet-page__example-image').addClass('bookmarklet-page__example-image--active');
      });
      $(document).on('mouseenter', '.bookmarklet-page__example-image', () => {
        $('.bookmarklet-page__example-image').removeClass(
          'bookmarklet-page__example-image--active'
        );
      });
      $(document).on('mouseleave', '.bookmarklet-page__example', () => {
        $('.bookmarklet-page__example-image').removeClass(
          'bookmarklet-page__example-image--active'
        );
      });

      $(document).on('click', '.bookmarklet-page__dashed-underline', (e) => {
        const targetId = $(e.target).attr('href');
        const headerHeight = $('.header').first().outerHeight() || 0;
        const scrollPosition = $(`${targetId}`).offset().top - headerHeight;

        window.scroll({
          top: scrollPosition,
          behavior: 'smooth',
        });
        return false;
      });
    }
    if ($('body').is('#bookmarklet-form, #bookmarklet-create')) {
      function sendMessage(msg) {
        window.parent.postMessage(msg, '*');
      }
      function receiveMessage(e) {
        if (updatePropertiesCount === 0) {
          autoPopulatedProperties = e.data;
          setElapsedTimeToNow();
        }
        updatePropertiesCount++;

        $('.bookmarklet-picker--image').removeClass('bookmarklet-picker--image-active');
        // populate appropriate fields with received data
        if (e.data.name) {
          $('textarea[name="item[name]"]').val(e.data.name);
        }
        if (e.data.vendor) {
          $('input[name="item[vendor]"]').val(e.data.vendor);
        }
        if (e.data.url) {
          $('input[name="item[url]"]').val(e.data.url);
        }
        if (e.data.unit_price) {
          $('input[name="item[unit_price]"]').val(e.data.unit_price).change();
        }
        if (e.data.msrp) {
          $('input[name="item[msrp]"]').val(e.data.msrp);
        }
        if (e.data.sku) {
          $('input[name="item[sku]"]').val(e.data.sku);
        }
        if (e.data.description) {
          $('textarea[name="item[description]"]').val(e.data.description);
        }
        if (e.data.dimensions) {
          $('input[name="item[dimensions]"]').val(e.data.dimensions);
        }
        if (e.data.estLeadTime) {
          $('input[name="item[est_lead_time]"]').val(e.data.estLeadTime);
        }
        if (e.data.materials) {
          $('input[name="item[materials]"]').val(e.data.materials);
        }
        if (e.data.notes) {
          $('textarea[name="item[notes]"]').val(e.data.notes);
        }
        if (e.data.image_url || e.data.primary_image) {
          const src = e.data.image_url || e.data.primary_image;

          $('input[name="image_url"]').val(src);
          $('.bookmarklet-image').attr('src', src);
        }
        if (e.data.imageUrlCanvas) {
          $('input[name="image_base64"]').val(e.data.imageUrlCanvas);
          updateCanvasProcessingStatus();
          setFailedCanvasImage(e.data.isBlank, e.data.originalSrc);
        }
        if (e.data.additionalImageUrlCanvas) {
          $('.bookmarklet-picker--additional-image').before(`
            <input type="hidden" name="additional_image_base64[]" value="${e.data.additionalImageUrlCanvas}">
        `);
          updateCanvasProcessingStatus();
          setFailedCanvasImage(e.data.isBlank, e.data.originalSrc);
        }
        if (e.data.additional_image) {
          $('.bookmarklet-picker--additional-image').before(`
          <div class="bookmarklet-additional-image">
            <img class="bookmarklet-additional-image__preview" src="${e.data.additional_image}">
            <input type="hidden" name="additional_image_urls[]" value="${e.data.additional_image}">
            <a class="bookmarklet-additional-image__delete-link">
              <span class="bookmarklet-tooltip">Delete Image</span>
            </a>
          </div>
        `);
          toggleAdditionalImagesPicker();
        }
        if (e.data.resubmitForm) {
          $('.bookmarklet-loading-canvas__text').html(
            '<i class="fa-solid fa-loader fa-spin"></i> Uploading to your library..'
          );
          $('.p-button--bookmarklet-save').click();
        }

        function setFailedCanvasImage(isBlank, originalSrc) {
          if (isBlank) {
            $('.bookmarklet-form').prepend(`
            <input type="hidden" name="failed_canvas_images[]" value="${originalSrc}">
        `);
          }
        }
        function updateCanvasProcessingStatus() {
          // mark currently processing image as completed
          $('.bookmarklet-loading-canvas__processing')
            .removeClass('bookmarklet-loading-canvas__processing')
            .addClass('bookmarklet-loading-canvas__completed');

          // mark next image (if any) as processing
          if ($('.bookmarklet-loading-canvas__idle').length > 0) {
            $('.bookmarklet-loading-canvas__idle')
              .first()
              .removeClass('bookmarklet-loading-canvas__idle')
              .addClass('bookmarklet-loading-canvas__processing');
          }
        }

        // remove picker active state
        $('.bookmarklet-picker--active').removeClass('bookmarklet-picker--active');
        $('.bookmarklet-picker--additional-image').removeClass(
          'bookmarklet-picker--active-additional-image'
        );
      }

      // refresh
      $(document).on('click', '.bookmarklet-refresh__button', function (event) {
        event.preventDefault();

        // Remove any additional image selected.
        document
          .querySelectorAll('.bookmarklet-additional-image')
          .forEach((image) => image.remove());
        // Remove any value from the form inputs.
        document.querySelector('.bookmarklet-form').reset();
        // Uncheck any project selected (but the default).
        document
          .querySelectorAll('input[name="projects[]"]:checked')
          .forEach((input) => (input.checked = false));
        // Reset the projects selector field text.
        document.querySelector('.projects-dropdown__label-text.field').innerText = 'My Library';
        // Remove the product category if selected.
        $('.selectized-category')[0].selectize.clear();
        // Remove any tag selected and/or created.
        $('.field--bookmarklet-tags')[0].selectize.clear();

        sendMessage(['initialize', $(this).data().kind]);
      });

      document
        .querySelector('.bookmarklet-next-image')
        ?.addEventListener('click', () => sendMessage(['change-image', 'right']));

      document
        .querySelector('.bookmarklet-previous-image')
        ?.addEventListener('click', () => sendMessage(['change-image', 'left']));

      $(document).on('click', '.bookmarklet-additional-image__delete-link', (e) => {
        $(e.target).parent('.bookmarklet-additional-image').remove();
        toggleAdditionalImagesPicker();
      });

      const toggleAdditionalImagesPicker = () => {
        const { classList } = document.querySelector('.bookmarklet-picker--additional-image');
        const additionalImagesClipped = document.querySelectorAll(
          '.bookmarklet-additional-image__preview'
        ).length;

        classList.toggle('hide', additionalImagesClipped === config.maxAdditionalImages);
      };

      // select some data
      $(document).on(
        'click',
        `.bookmarklet-picker--image,
      .bookmarklet-picker--additional-image,
      .bookmarklet-picker--name,
      .bookmarklet-picker--unit-price,
      .bookmarklet-picker--sku,
      .bookmarklet-picker--msrp,
      .bookmarklet-picker--description,
      .bookmarklet-picker--dimensions,
      .bookmarklet-picker--materials,
      .bookmarklet-picker--notes`,
        function () {
          $('.bookmarklet-picker--image').removeClass('bookmarklet-picker--image-active');
          const $this = $(this);
          $('.bookmarklet-picker--active').removeClass('bookmarklet-picker--active');
          $('.bookmarklet-picker--additional-image').addClass(
            'bookmarklet-picker--active-additional-image'
          );
          $this.addClass('bookmarklet-picker--active');
          sendMessage(['pick', $this.data().kind]);
        }
      );
      $(document).on('change keyup paste input', '.field--bookmarklet-name', (e) => {
        $(e.target).val(e.target.value.replace(/\n/g, ''));
      });

      // submit form
      $(document).on('click', '.p-button--bookmarklet-save', (e) => {
        e.preventDefault();
        const $form = $(e.target).parents('form');
        $(e.target).prop('disabled', true).addClass('button-loading');

        const name = $form.find("[name='item[name]']").val();
        const clientFacingName = $form.find("[name='item[client_facing_name]']").val();
        const vendor = $form.find("[name='item[vendor]']").val();
        const unitPrice = $form.find("[name='item[unit_price]']").val();
        const msrp = $form.find("[name='item[msrp]']").val();
        const sku = $form.find("[name='item[sku]']").val();
        const description = $form.find("[name='item[description]']").val();
        const dimensions = $form.find("[name='item[dimensions]']").val();
        const materials = $form.find("[name='item[materials]']").val();
        const estLeadTime = $form.find("[name='item[est_lead_time]']").val();
        const estShippingCost = $form.find("[name='item[est_shipping_cost]']").val();
        const notes = $form.find("[name='item[notes]']").val();
        const url = $form.find("[name='item[url]']").val();
        const formValues = {
          name,
          client_facing_name: clientFacingName,
          vendor,
          unit_price: unitPrice,
          msrp,
          sku,
          description,
          dimensions,
          materials,
          est_lead_time: estLeadTime,
          est_shipping_cost: estShippingCost,
          notes,
          url,
        };

        const analytics = calculateAnalytics(formValues);
        $form.find("[name='analytics[fields_auto_count]']").val(analytics.fields_auto_count);
        $form.find("[name='analytics[fields_manual_count]']").val(analytics.fields_manual_count);
        $form
          .find("[name='analytics[fields_corrected_count]']")
          .val(analytics.fields_corrected_count);
        $form.find("[name='analytics[time_to_finalize]']").val(analytics.time_to_finalize);

        $form.submit();

        return false;
      });

      // close sidebar
      $(document).on(
        'click',
        '.t-button--bookmarklet-cancel-link, .p-button--bookmarklet-close',
        function () {
          sendMessage(['close']);
          resetAnalytics();

          return false;
        }
      );

      // setup listener to receive messages from the client
      window.addEventListener('message', receiveMessage);

      // notify client that form has been loaded and grab default data
      if ($('body').is('#bookmarklet-form')) {
        sendMessage(['initialize']);
      }

      // if we're back to create form with reattempt_with_canvas flag, trigger canvas
      if ($('body').is('#bookmarklet-create') && $('#reattempt_with_canvas').val() === 'true') {
        const additionalImages = $("input[name='additional_image_urls[]']")
          .map(function () {
            return $(this).val();
          })
          .get();

        sendMessage(['reattempt_with_canvas', [$('#image_url').val(), additionalImages]]);
      }
      prepareCheckDropdown();

      $('.selectized-category').selectize({
        placeholder: 'Choose or create new category...',
        sortField: {
          field: 'text',
          direction: 'asc',
        },
        create(categoryName, callback) {
          $.post('/bookmarklet/xhr_create_item_category', {
            name: categoryName,
            uuid: $('#uuid').val(),
          }).done((res) => {
            callback({ value: res.id, text: res.name });
          });
        },
      });
    }

    $(document).on('click', '.bookmarklet-picker--image', (e) => {
      $(e.target).addClass('bookmarklet-picker--image-active');
    });

    $(document).on('change keyup paste input', '.field--projects-dropdown-search', (e) => {
      const searchWord = $(e.target).val().toLowerCase();
      $('.projects-dropdown__no-results').hide();
      $('.checkbox__label')
        .hide()
        .each((e) => {
          if ($('.checkbox__label').eq(e).text().toLowerCase().indexOf(searchWord) >= 0) {
            $('.checkbox__label').eq(e).show();
          }
        });
      if ($('.checkbox__label:visible').length === 0) {
        $('.projects-dropdown__no-results').show();
      }
    });
  });
});
